<h3 color="primary" class="popup-header">Patient History</h3>
<mat-dialog-content class="mat-typography">
  <ng-container *ngFor="let item of patientInfo">
    <div class="historyGrid">
      <pre style="margin: 5px 0px;">{{item?.history}}</pre>
    </div>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions class="popup-footer">
  <button mat-raised-button color="warn" (click)="cancelClick()">
    <i class="fas fa-times"></i> Close
  </button>
</mat-dialog-actions>